import { ConfigService } from "./ConfigService";

export default ConfigService;
